import { Alert } from '@cmsgov/design-system'
import { useTranslation } from 'react-i18next'

export function EasyPayEnrolledAlert () {
  const { t } = useTranslation('makeAPaymentPage', { keyPrefix: 'payYourPremium.easyPayEnrolledAlert' })

  return (
    <Alert heading={t('heading')} variation='warn' className='ds-u-measure--wide'>
      {t('content')}
    </Alert>
  )
}

export default EasyPayEnrolledAlert
